module.exports = __webpack_public_path__ + "static/media/logo_no_text.11b73910.png";